import { useEffect, useState } from "react";
import QRCode from "qrcode";

interface QrCodeProps {
  /** The text the code carries. */
  value: string;
  /** Side in CSS pixels. */
  size?: number;
  /** What the code is, for a screen reader. */
  label: string;
}

// A QR code drawn in the browser: what it carries (a pairing code) must
// never travel to a server to be rendered.
export function QrCode({ value, size = 200, label }: QrCodeProps) {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    QRCode.toDataURL(value, {
      width: size * 2,
      margin: 1,
      errorCorrectionLevel: "M",
    })
      .then((url) => live && setSrc(url))
      .catch(() => live && setSrc(null));
    return () => {
      live = false;
    };
  }, [value, size]);
  return src ? <img src={src} width={size} height={size} alt={label} /> : null;
}
